import { useCallback, useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { HomeAnnouncementCard } from '../molecules/HomeAnnouncementCard';
import { HomeCarouselControls } from '../molecules/HomeCarouselControls';
import { HomeDailyTip } from '../molecules/HomeDailyTip';
import { useHomeAnnouncements } from '../../hooks/useHomeAnnouncements';

export const HomeAnnouncements = () => {
  const classes = useStyles();
  const announcements = useHomeAnnouncements();
  const [index, setIndex] = useState<number>(0);
  const [isHovered, setIsHovered] = useState<boolean>(false);
  const { length } = announcements;

  useEffect(() => {
    setIndex(current => (length === 0 ? 0 : Math.min(current, length - 1)));
  }, [length]);

  const handlePrevious = useCallback(() => {
    setIndex(current => (current === 0 ? length - 1 : current - 1));
  }, [length]);

  const handleNext = useCallback(() => {
    setIndex(current => (current + 1 >= length ? 0 : current + 1));
  }, [length]);

  const handleMouseEnter = useCallback(() => setIsHovered(true), []);
  const handleMouseLeave = useCallback(() => setIsHovered(false), []);

  useEffect(() => {
    if (length < 2 || isHovered) return undefined;
    const interval = setInterval(handleNext, 8000);
    return () => clearInterval(interval);
  }, [handleNext, isHovered, length]);

  const selected = announcements[index];
  if (!selected) return <HomeDailyTip />;

  return (
    <Box className={classes.section}>
      <Box className={classes.shell}>
        <HomeAnnouncementCard
          announcement={selected}
          index={index}
          length={length}
          onPrevious={handlePrevious}
          onNext={handleNext}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        />
        {length > 1 && (
          <HomeCarouselControls
            announcements={announcements}
            index={index}
            onSelect={setIndex}
          />
        )}
        <HomeDailyTip embedded />
      </Box>
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  section: { marginBottom: theme.spacing(3) },
  shell: {
    border: `1px solid ${theme.palette.border}`,
    borderRadius: 8,
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
}));
